<script lang="ts">
import truncate from "@/composable/components/title";
import { BTooltip } from "buefy";
import "@/style/components/TitleAndDescription.scss";
import { PropType } from "vue";

type TooltipPosition = "is-top" | "is-bottom" | "is-left" | "is-right" | undefined;

export default {
  name: "TitleCardWithLimitLength",
  components: { BTooltip },
  props: {
    localName: {
      type: String,
      required: true,
      default: "",
    },
    limit: {
      type: Number,
      required: true,
      default: 10,
    },
    position: {
      type: String as PropType<TooltipPosition>,
      required: false,
      default: "is-top",
    },
  },
  methods: { truncate },
};
</script>

<template>
  <b-tooltip
    v-if="localName.length > limit"
    :label="localName"
    :aria-label="localName"
    :position="position"
  >
    <span
      class="spanStyleForTitle"
      field="name"
    >
      {{ truncate(localName, limit) }}
    </span>
  </b-tooltip>
  <span
    v-else
    field="name"
    :aria-label="localName"
  >{{ localName }}</span>
</template>
